'use strict';

angular.module('app').directive('dropdownMultiselect', function (utils) {
  return {
    restrict: 'A',
    link: function(scope, elem, attrs, ctrl) {
      var isActive = false,
          ev = utils.isMobile() ? 'touchend' : 'click',
          $elem = $(elem),
          clickingCallback = function(el,p) {
            $elem.addClass('open');
            isActive = true;
          };

          $elem.addClass('multi-select');

          if (attrs.whiteColor) {
              $elem.addClass('white');
          }
          elem.on(ev, clickingCallback);

        $(document).on(ev, function(e){
            if ( $(e.target).closest(elem).length === 0 && isActive) {
                $elem.removeClass('open');
                isActive = false;
            }
        });
    }
  };
})
